import { SVGProps } from 'react';

export interface IconToolsGradientProps extends SVGProps<SVGSVGElement> {
	testId?: string;
}

const IconToolsGradient = (props: IconToolsGradientProps) => {
	const { testId = 'IconToolsGradient' } = props;

	return (
		<svg
			data-testid={testId}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label="tools"
			{...props}
		>
			<path
				d="M28.2566 5.57121C26.0033 5.55709 23.3161 6.44196 21.754 8.00407C19.5457 10.2123 19.1005 13.1994 20.3453 15.9692C19.7021 16.5646 18.8929 17.2733 17.9576 18.0651L11.8748 11.9823V10.7531C11.8748 10.4012 11.7051 10.0706 11.4183 9.86564L8.33721 7.66594C7.98346 7.41344 7.49969 7.45365 7.19219 7.76115L5.88604 9.0673C5.57854 9.37481 5.53832 9.85857 5.79082 10.2123L7.99053 13.2934C8.19553 13.5803 8.52548 13.7499 8.87798 13.7499H10.1072L16.0301 19.6728C15.5712 20.0541 15.1497 20.4118 14.6873 20.7946C12.0373 22.989 9.53298 25.0627 8.25298 26.3427C6.41798 28.1771 6.41798 31.1617 8.25298 32.9967C9.17048 33.9142 10.3756 34.3725 11.5806 34.3725C12.7856 34.3725 13.9908 33.9142 14.9083 32.9967C16.0308 31.8742 18.1765 29.2979 20.449 26.5697C22.273 24.3809 24.1054 22.1899 25.2781 20.9106C26.2878 21.3645 27.3263 21.5929 28.3458 21.5929C30.1233 21.5929 31.8413 20.8983 33.2444 19.4946C35.7438 16.9958 36.5099 11.6174 34.6336 9.74113C34.1455 9.25301 33.3548 9.25363 32.866 9.74113L28.8816 13.7255C28.4048 13.6818 27.9423 13.5869 27.7623 13.4863C27.6616 13.3056 27.5661 12.8431 27.523 12.3669L31.5074 8.38249C31.9955 7.89437 31.9955 7.10426 31.5074 6.61613C30.8038 5.91277 29.6087 5.57969 28.2566 5.57121ZM28.2701 8.08708L25.366 10.9911C25.1316 11.2255 24.9998 11.5437 24.9998 11.8749C24.9998 12.5943 25.096 14.3643 25.991 15.2587C26.8854 16.1537 28.6554 16.2499 29.3748 16.2499C29.7061 16.2499 30.0242 16.1175 30.2586 15.8825L33.1627 12.9784C33.1489 14.4253 32.6669 16.537 31.4769 17.727C29.1587 20.0426 26.1259 19.0813 24.1465 17.1032C22.1665 15.1232 21.2059 12.0885 23.5215 9.77287C24.7122 8.58225 26.8232 8.10083 28.2701 8.08708ZM21.7027 18.1225C21.9137 18.3762 22.1355 18.6261 22.379 18.8696C22.623 19.1135 22.8741 19.3381 23.1285 19.5495C21.9298 20.888 20.2693 22.8808 18.5289 24.9706C16.392 27.535 14.1826 30.1873 13.1407 31.2292C12.2807 32.0885 10.8818 32.0885 10.0206 31.2292C9.16056 30.3692 9.16056 28.9703 10.0206 28.1103C11.2181 26.9134 13.7934 24.7809 16.2828 22.7197C18.3532 21.0046 20.3148 19.376 21.7027 18.1225ZM25.5467 23.0505L24.5384 24.2101L29.5433 29.215C30.1508 29.8225 30.1508 30.8115 29.5433 31.4184C28.9551 32.0065 27.9292 32.0071 27.3411 31.4184L22.5279 26.6051L20.919 28.5326L25.5735 33.186C26.3398 33.9528 27.3584 34.3749 28.4422 34.3749C29.5259 34.3749 30.5452 33.9528 31.3121 33.186C32.8939 31.6041 32.8939 29.0312 31.3121 27.4487L27.1727 23.3092L25.5467 23.0505Z"
				fill="url(#paint0_linear_4745_2991)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_4745_2991"
					x1="14.7496"
					y1="-22.0327"
					x2="58.5393"
					y2="0.646904"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default IconToolsGradient;
